import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import UndoIcon from '@mui/icons-material/Undo';
import { formatearFecha } from '../../utils/utils';

export const DialogAceptarModificacion = ({ open, setOpen, fichaje, tipo, actualizarFichajePendiente, index }) => {

    if (!fichaje) return null;
    console.log(open, fichaje, tipo);

    const esCorreccion = tipo === "correccion";
    const esAnulacion = tipo === "anulacion";

    // ID seguro para aceptar corrección o anulación
    const idSeguro =
        fichaje.fichaje_modificado?.id ??  // SI EXISTE MODIFICADO → ESTE
        fichaje.fichaje_original?.id ??    // SI NO, EL ORIGINAL
        fichaje.id_fichaje;

    console.log("a", idSeguro);

    const handleAceptar = () => {
        if (!idSeguro) return;

        if (esCorreccion) {
            actualizarFichajePendiente(idSeguro, 1, "correccion");
        } else {
            actualizarFichajePendiente(idSeguro, 1, "anulacion");
        }
    };

    return (
        <Dialog
            open={open === index}
            onClose={() => setOpen(null)}
            fullWidth
            maxWidth='md'
        >
            <DialogTitle>
                <Grid
                    container
                    direction="row"
                    justifyContent="start"
                    alignItems="center"
                    xs={12}
                >
                    <Typography variant='h5' sx={{ textAlign: 'left' }}>
                        <DoneAllIcon sx={{ mb: -1, fontSize: 35 }} color='success' />

                        {esCorreccion && (
                            <> Aceptar modificación del fichaje Nº{idSeguro ?? "—"}</>
                        )}

                        {esAnulacion && (
                            <> Aceptar anulación del fichaje Nº{idSeguro ?? "—"}</>
                        )}
                    </Typography>

                    <Divider sx={{ width: '100%', mt: 1 }} />
                </Grid>
            </DialogTitle>

            <DialogContent>
                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="start"
                    xs={12} gap={1}
                >
                    <Typography variant='body1' sx={{ textAlign: 'left' }}>
                        {esCorreccion && (
                            <>
                                ¿Estás seguro de que deseas aceptar la modificación del fichaje Nº{idSeguro}?<br />
                                Al aceptar, el fichaje original será reemplazado por el modificado.
                            </>
                        )}

                        {esAnulacion && (
                            <>
                                ¿Estás seguro de que deseas aceptar la anulación del fichaje Nº{idSeguro}?<br />
                                El fichaje será eliminado definitivamente.
                            </>
                        )}
                    </Typography>

                    {/* SIEMPRE segura */}
                    {esCorreccion && (
                        <Grid container direction="column" gap={2} xs={12}>

                            {/* ORIGINAL — puede NO existir */}
                            {fichaje.fichaje_original ? (
                                <Grid container xs={12} sx={{
                                    backgroundColor: 'lightgray',
                                    p: 0.5,
                                    borderLeft: "5px solid gray",
                                    borderRadius: 2
                                }}>
                                    <Typography variant='subtitle1'>Fichaje original</Typography>
                                    <Divider sx={{ width: '100%', my: 0.5 }} />

                                    <Grid container justifyContent="space-between">
                                        <Typography>Inicio: {fichaje.fichaje_original?.hora_inicio ?? "—"}</Typography>
                                        <Typography>Fin: {fichaje.fichaje_original?.hora_fin ?? "—"}</Typography>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid container xs={12} sx={{
                                    backgroundColor: '#ffe6cc',
                                    p: 0.5,
                                    borderLeft: "5px solid #ff9900",
                                    borderRadius: 2
                                }}>
                                    <Typography variant='subtitle1'>No existe fichaje original</Typography>
                                    <Divider sx={{ width: '100%', my: 0.5 }} />

                                    <Typography variant='body2'>
                                        Este fichaje fue creado manualmente para corregir una ausencia.
                                    </Typography>
                                </Grid>
                            )}

                            {/* Flecha solo si hay original */}
                            {fichaje.fichaje_original && (
                                <Grid container justifyContent="center">
                                    <KeyboardDoubleArrowRightIcon color='action' sx={{ fontSize: 40, transform: 'rotate(90deg)' }} />
                                </Grid>
                            )}

                            {/* MODIFICADO — siempre debe existir */}
                            <Grid container xs={12} sx={{
                                backgroundColor: 'lightgreen',
                                p: 0.5,
                                borderLeft: "5px solid green",
                                borderRadius: 2
                            }}>
                                <Typography variant='subtitle1'>Fichaje modificado</Typography>
                                <Divider sx={{ width: '100%', my: 0.5 }} />

                                <Grid container justifyContent="space-between">
                                    <Typography>Inicio: {formatearFecha(fichaje.fichaje_modificado?.hora_inicio) ?? "—"}</Typography>
                                    <Typography>Fin: {formatearFecha(fichaje.fichaje_modificado?.hora_fin) ?? "—"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}

                </Grid>
            </DialogContent>

            <DialogActions>
                <Grid container justifyContent={{ xs: "space-between", md: "end" }} gap={2}>
                    <Button color='success' variant='contained' onClick={handleAceptar}>
                        <DoneAllIcon sx={{ mt: -0.3, fontSize: 20 }} /> Aceptar
                    </Button>

                    <Button variant='text' onClick={() => setOpen(null)}>
                        <UndoIcon sx={{ mt: -0.3, fontSize: 20 }} /> Atrás
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
